// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import videojs from 'video.js';
import lightbox from 'lightbox2';
import 'videojs-youtube';
import 'videojs7-vimeo';
import 'is-in-viewport';
import 'jquery-match-height';
import 'slick-carousel';

import { Drawer } from './drawer';

lightbox.option({
  resizeDuration: 1,
  disableScrolling: true,
  showImageNumberLabel: true,
  albumLabel: ' %1 / %2 ',
  imageFadeDuration: 1,
});

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js